import { Injectable, isDevMode } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';
import { Observable } from 'rxjs';

/**
 * Prevent access to routes if access-token is not present.
 *
 * @export
 * @class AuthGuard
 * @implements {CanActivate}
 */
@Injectable()
export class AuthGuard {
  constructor(private _router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return getCurrentUser()
      .then(() => {
        return true;
      })
      .catch(() => {
        if (isDevMode()) {
          console.log('[DEV] [AuthGuard] user not authenticated, redirecting to signin');
          console.log('[DEV] [AuthGuard] returnUrl:', state.url);
        }
        this._router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
        return false;
      });
  }
}
